import React from 'react';

const AvailableVolumeFromRain = ({ valid, rainVolume, roofArea, setVolume }) => {
  
  if(!valid){
    setVolume(null);
    return <div/>
  }

  // Experimantal coeficient (Fraction of water that does not evaporate)
  const fs = 0.95;

  // Hydraulic efficiency of filter given by manufacturer. What filter, idk
  const ff = 0.9;

  // Formula given by client
  const availableVolume = rainVolume * roofArea * fs * ff * 20 / 1000 / 365;

  setVolume(availableVolume);

  return (
    <div>
      <h3>Dostupné množství dešťové vody</h3>
      <div className="calc-result">{availableVolume.toFixed(1)} m<sup>3</sup></div>
    </div>
  );
}

export default AvailableVolumeFromRain;